import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";

export const LoadingPageState = () => (
  <div className="flex min-h-screen w-full items-center justify-center bg-unbox-cream-25">
    <LoadingIndicator size="md" label="Loading..." />
  </div>
);
